var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  d: "M0 9V7h2.288a7 7 0 0 1 7-7h3v16h-3a7 7 0 0 1-7-7H0zm19.288-9a7 7 0 0 1 7 7h2.21v2h-2.21a7 7 0 0 1-7 7h-3v-4h-2v-2h2V6h-2V4h2V0h3zm-9 2h-1a5 5 0 0 0-4.995 4.783L4.288 7v2a5 5 0 0 0 4.783 4.995l.217.005h1V2zm9 0h-1v12h1a5 5 0 0 0 4.996-4.783L24.288 9V7a5 5 0 0 0-5-5z",
  id: "0kkqf1x5ha"
}));
var _ref3 = /*#__PURE__*/React.createElement("use", {
  fill: "currentColor",
  xlinkHref: "#0kkqf1x5ha",
  transform: "translate(.003)",
  fillRule: "evenodd"
});
function SvgApiIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 16,
    viewBox: "0 0 29 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApiIcon);
export default __webpack_public_path__ + "static/media/apiIcon.8058c6228052a8b7c8ded333100a9b01.svg";
export { ForwardRef as ReactComponent };